<template>
  <label for="isBrandMx">{{
    t('sites.singleSite.financialConfig.mealPlans.form.mealsStation')
  }}</label>
  <SelectButtonField
    :id="`isBrandMx`"
    :name="`${formNamespace}isBrandMX`"
    :options="brandMXOptions"
    optionLabel="label"
    optionValue="value"
    :unselectable="false"
    :disabled="isBrandMEQ || isBrandMEQFieldValue || !hasMXTenders || !editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import useTenderType from '../../composables/use-tender-type/use-tender-type';
import { inject } from 'vue';
import { useFieldValue } from 'vee-validate';
import { useFinancialConfigStore } from '@/views/app-modules/sites/src/routes/stores';

const { t } = useI18n();

const { brandMXOptions, isBrandMEQ, hasMXTenders } = useTenderType();

const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');
const isBrandMEQFieldValue = useFieldValue<string>(`${formNamespace}isBrandMEQ`);
</script>
